import { Container } from "@material-ui/core";
import { Header } from "../../shared/Style/Style";
import { SettingsInner } from "./Settings.style";
import { ThemeBackground } from "./ThemeBackground";
import { ManualDiscounts } from "./ManualDiscounts";
import { QuotesCollection } from "./QuotesCollection/QuotesCollection";
import { TestGenerator } from "./AIGenerator";
import { ScheduledMaintenanceComponent } from "./ScheduledMaintenance/ScheduledMaintenanceComponent";

export const Settings = () => {
  return (
    <Container maxWidth="lg">
      <Header>Налаштування</Header>
      <SettingsInner>
        <ScheduledMaintenanceComponent />
        <TestGenerator />
        <ManualDiscounts />
        <ThemeBackground />
        <QuotesCollection />
      </SettingsInner>
    </Container>
  );
};
